<!-- Navigation -->
<nav class="bg-white dark:bg-slate-800 shadow-sm dark:shadow-slate-900/30 fixed w-full top-0 z-50">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex justify-between items-center h-16">
      <div class="flex items-center cursor-pointer" (click)="goHome()">
        <div class="flex-shrink-0 flex items-center">
          <div
            class="w-10 h-10 rounded-lg feature-icon flex items-center justify-center mr-3"
          >
            <span class="text-white text-xl font-bold">P</span>
          </div>
          <span class="text-2xl font-bold gradient-text">Predivent</span>
        </div>
      </div>

      <div class="hidden md:flex items-center space-x-8">
        <a
          (click)="navigateToSection('fonctionnalites')"
          class="text-gray-700 dark:text-gray-300 hover:text-purple-600 transition cursor-pointer"
          >Fonctionnalités</a
        >
        <a
          (click)="navigateToSection('tarifs')"
          class="text-gray-700 dark:text-gray-300 hover:text-purple-600 transition cursor-pointer"
          >Tarifs</a
        >
        <a
          (click)="navigateToSection('temoignages')"
          class="text-gray-700 dark:text-gray-300 hover:text-purple-600 transition cursor-pointer"
          >Témoignages</a
        >
        <a
          (click)="navigateToSection('faq')"
          class="text-gray-700 dark:text-gray-300 hover:text-purple-600 transition cursor-pointer"
          >FAQ</a
        >
      </div>

      <div class="flex items-center space-x-4">
        <a
          routerLink="/login"
          class="text-gray-700 dark:text-gray-300 hover:text-purple-600 transition font-medium"
          >Connexion</a
        >
        <a
          routerLink="/register"
          class="bg-gradient-to-r from-purple-600 to-purple-700 text-white px-6 py-2 rounded-lg hover:from-purple-700 hover:to-purple-800 transition font-medium"
        >
          Essai gratuit
        </a>
      </div>
    </div>
  </div>
</nav>
